<template>
  <div>
    <ControlPanel :card="false" :icon="'mdi mdi-file'" :title="'Справка о зарплате'" :links="links" :premium="true">
      <b-button size="sm" variant="primary" class="mr-1" @click="doCertificate()"><span class="mdi mdi-file-document"></span> Сформировать</b-button>
      <b-button size="sm" variant="dark" @click="Print('printBodyCertificate', 'portrait')"><span class="mdi mdi-printer"></span> Печать</b-button>
    </ControlPanel>

    <div class="row" v-if="user.registered && !user.subscribe_expired">
      <div class="col-md-4">
        <b-card header-class="bg-secondary text-white" class="mb-1">
          <template v-slot:header>
            Параметры
          </template>
          <div class="row">
            <div class="col-md-12">
              <b-form-group>
                <SelectOrg :title="['Организация', 'Организация']" :name="'orgs'" :table="'reg_organizations'"
                           :fields="['name']"></SelectOrg>
              </b-form-group>
              <b-form-group>
                <SelectWorker :title="['Сотрудник', 'Сотрудник']"></SelectWorker>
              </b-form-group>
              <b-form-group>
                <b-input-group size="sm">
                  <template #prepend>
                    <b-input-group-text>Период с</b-input-group-text>
                  </template>
                  <Enums :type="'enum'" :name="'months'" v-model="params.period.from.month"></Enums>
                  <Enums :type="'enum'" :name="'years'" v-model="params.period.from.year"></Enums>
                </b-input-group>
              </b-form-group>

              <b-form-group>
                <b-input-group size="sm">
                  <template #prepend>
                    <b-input-group-text>Период по</b-input-group-text>
                  </template>
                  <Enums :type="'enum'" :name="'months'" v-model="params.period.to.month"></Enums>
                  <Enums :type="'enum'" :name="'years'" v-model="params.period.to.year"></Enums>
                </b-input-group>
              </b-form-group>
            </div>

            <div class="col-md-6">
              <b-form-group>
                <b-form-input size="sm" type="date" v-model="params.date"></b-form-input>
                <small class="form-text text-muted">Дата предоставления</small>
              </b-form-group>
            </div>

            <div class="col-md-6">
              <b-form-group>
                <b-form-input size="sm" type="number" v-model="params.number" min="0"></b-form-input>
                <small class="form-text text-muted">Номер справки</small>
              </b-form-group>
            </div>

            <div class="col-md-12">
              <b-form-group>
                <b-form-input size="sm" type="text" v-model="params.destination"></b-form-input>
                <small class="form-text text-muted">Кому предоставляется справка</small>
              </b-form-group>

              <b-form-group>
                <b-form-input size="sm" type="text" v-model="org.chief"></b-form-input>
                <small class="form-text text-muted">Руководитель</small>
              </b-form-group>

              <b-form-group>
                <b-form-input size="sm" type="text" v-model="org.accountant"></b-form-input>
                <small class="form-text text-muted">Главный бухгалтер</small>
              </b-form-group>
            </div>
          </div>




        </b-card>
      </div>
      <div class="col-md-8">
        <b-card header="Справка о зарплате" header-bg-variant="secondary" header-text-variant="white">
          <PrintCertificate :org="org" :worker="worker" :params="params" :result="result"></PrintCertificate>
        </b-card>

      </div>
    </div>

    <Premium v-else />
  </div>
</template>


<script>
import ControlPanel from "@/components/base/ControlPanel"
import SelectOrg from "@/components/base/SelectOrg"
import SelectWorker from "@/components/base/SelectWorker"
import Enums from "@/components/base/Enums"
import PrintCertificate from "@/components/print/Certificate"
import Premium from "@/components/base/Premium"
import {mapGetters} from "vuex";

export default {
  name: 'DocsSalaryCertificate',
  components: {
    ControlPanel,
    SelectOrg,
    SelectWorker,
    Enums,
    PrintCertificate,
    Premium
  },
  data: function () {
    return {
      links: [
        {name: 'Расчётный листок', link: '/docs/payslip/', icon: 'mdi mdi-file'},
        {name: 'Калькулятор заработной платы', link: '/', icon: 'mdi mdi-calculator'},
      ],
      params: {
        period: {
          from: {
            month: '0',
            year: new Date().getFullYear()
          },
          to: {
            month: '0',
            year: new Date().getFullYear()
          }
        },
        date: '', //new Date(),
        number: 0,
        destination: ''
      },
      result: {
        list: []
      }
    }
  },
  methods: {
    doCertificate: function () {
      this.$store.commit('wait', {state: true, name: 'Формирование справки о зарплате'});
      this.$http
          .post(this.$apiold, {
            task: 'salary-certificate',
            params: this.params,
            org: this.org,
            worker: this.worker
          })
          .then(response => {
            this.$store.commit('wait', {state: false});
            this.$store.commit('user', response.data.user);

            this.result = response.data.result;

            // Сообщения
            this.$store.commit('alert', response.data.messages);
          })
    }
  },
  computed: {
    ...mapGetters({
      org: 'org',
      worker: 'worker',
      user: 'user'
    })
  }

}
</script>


<style>

</style>
